// extracted by mini-css-extract-plugin
export var editInput = "_fc-0";
export var editInputCompact = "_fc-2";
export var editInputLarge = "_fc-1";
export var editInputSmall = "_fc-3";